import { render, staticRenderFns } from "./videoT.vue?vue&type=template&id=151b621c&scoped=true&"
import script from "./videoT.vue?vue&type=script&lang=js&"
export * from "./videoT.vue?vue&type=script&lang=js&"
import style0 from "./videoT.vue?vue&type=style&index=0&id=151b621c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151b621c",
  null
  
)

export default component.exports